import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.cue = bracketIndenting({ line: "//" })
